import { AlertTriangle } from "lucide-react";
import { useTaal } from "@/contexts/TaalContext";
import { oogstMeldingTekst, wachtendTekst } from "@/lib/oogstmelding";

/**
 * De oogst staat stil of is mislukt, en waarom (opdracht Frank 21 oktober 2026). Van
 * 19 september tot 21 oktober zat het bakje vol en las de oogst niets, zonder dat het
 * ergens te zien was. Zonder melding tekent dit niets.
 */
function Blok({ tekst, testid }) {
  return (
    <section
      role="status"
      data-testid={testid}
      className="mb-4 max-w-prose rounded-lg border border-amber-500/50 bg-amber-500/10 p-3"
    >
      <h2 className="flex items-center gap-2 text-sm font-medium">
        <AlertTriangle className="h-4 w-4 shrink-0 text-amber-500" aria-hidden="true" />
        {tekst.titel}
      </h2>
      <p className="mt-1 text-xs text-muted-foreground">{tekst.uitleg}</p>
    </section>
  );
}

export default function OogstMelding({ melding, wachtend }) {
  const { t, taal } = useTaal();
  const stil = oogstMeldingTekst(melding, t, taal);
  const veel = wachtendTekst(wachtend, t);
  if (!stil && !veel) return null;
  return (
    <>
      {stil && <Blok tekst={stil} testid="oogst-melding" />}
      {veel && <Blok tekst={veel} testid="wachtend-melding" />}
    </>
  );
}
